import { IconButton } from '@monorepo/nova-ui';
import { styled } from '@mui/material/styles';

export const StyledCloseIconButton = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: theme.spacing(10.5),
  right: theme.spacing(6),
  padding: theme.spacing(2),
  '& svg': {
    stroke: theme.palette.secondaryInvert.main,
  },
  [theme.breakpoints.down('md')]: {
    top: theme.spacing(8),
    right: theme.spacing(6),
  },
}));
